/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Features
 */
export interface Features {
    /**
     * 
     * @type {string}
     * @memberof Features
     */
    'bodyType'?: FeaturesBodyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Features
     */
    'mileage'?: number;
    /**
     * 
     * @type {string}
     * @memberof Features
     */
    'fuelType'?: FeaturesFuelTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Features
     */
    'power'?: number;
    /**
     * 
     * @type {number}
     * @memberof Features
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof Features
     */
    'engineSize'?: number;
}

export const FeaturesBodyTypeEnum = {
    Suv: 'SUV',
    Sedan: 'SEDAN',
    Hatchback: 'HATCHBACK',
    Coupe: 'COUPE',
    Convertible: 'CONVERTIBLE',
    Estate: 'ESTATE',
    Mpv: 'MPV',
    Pickup: 'PICKUP'
} as const;

export type FeaturesBodyTypeEnum = typeof FeaturesBodyTypeEnum[keyof typeof FeaturesBodyTypeEnum];
export const FeaturesFuelTypeEnum = {
    Petrol: 'PETROL',
    Diesel: 'DIESEL',
    Electric: 'ELECTRIC',
    Hybrid: 'HYBRID',
    PlugInHybrid: 'PLUG_IN_HYBRID'
} as const;

export type FeaturesFuelTypeEnum = typeof FeaturesFuelTypeEnum[keyof typeof FeaturesFuelTypeEnum];


